import React from 'react';
import { bool, arrayOf, shape, func, string } from 'prop-types';
import { Formik } from 'formik';
import { extractRootKeys } from 'components/utils/search';
import { useLocation } from 'react-router-dom';
import useVelcro from './useVelcro';
import Query from './Query';

export function FormFilter({
  allowSkipInUrl,
  extraRootKeys,
  getParamsToBeHidden,
  handlers,
  parseInitialParams,
  query,
  render,
  schema,
  transform,
  transformUrl,
  transformVariables,
  variables,
  queryParams,
}) {
  const location = useLocation();
  const rootKeys = React.useMemo(() => extractRootKeys(query, extraRootKeys), [
    extraRootKeys,
    query,
  ]);
  const { initialValues, defaultValues, updateUrl } = useVelcro({
    allowSkipInUrl,
    schema,
    search: location?.search,
    rootKeys,
    parseInitialParams,
    getParamsToBeHidden,
    handlers,
  });

  if (!initialValues) {
    return null;
  }

  return (
    <Formik initialValues={initialValues}>
      {({ values, resetForm, setValues, setFieldValue }) => (
        <Query
          defaultValues={defaultValues}
          initialValues={initialValues}
          query={query}
          render={render}
          resetForm={resetForm}
          setValues={setValues}
          updateUrl={updateUrl}
          values={values}
          transform={transform}
          transformUrl={transformUrl}
          transformVariables={transformVariables}
          variables={variables}
          search={location?.search}
          setFieldValue={setFieldValue}
          queryParams={queryParams}
        />
      )}
    </Formik>
  );
}

FormFilter.propTypes = {
  allowSkipInUrl: bool,
  getParamsToBeHidden: func,
  handlers: arrayOf(shape({})),
  extraRootKeys: arrayOf(string),
  parseInitialParams: func,
  query: shape({}).isRequired,
  render: func.isRequired,
  schema: shape({}).isRequired,
  transform: func,
  transformUrl: func,
  transformVariables: func,
  variables: shape({}),
  queryParams: shape({}),
};

FormFilter.defaultProps = {
  allowSkipInUrl: false,
  extraRootKeys: [],
  getParamsToBeHidden: undefined,
  handlers: undefined,
  parseInitialParams: undefined,
  transform: undefined,
  transformUrl: undefined,
  transformVariables: undefined,
  variables: {},
  queryParams: {},
};

export default FormFilter;
